import {CanActivateFn, Router} from '@angular/router';
import {inject, Injectable} from '@angular/core';
import {AuthService} from '@core/services/auth.service';
import {PODE_ACAO_DEMANDA_KEY} from '@shared/constants/storage-keys';


@Injectable({providedIn: 'root'})
export class DemandaAcaoGuardService {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  canProceed(acao: 'adicionar' | 'reforcar' = 'adicionar'): boolean {
    if (!this.authService.isAuthenticated()) {
      if (this.authService.hasStorageToken()) {
        this.router.navigate(['/auth/session-expired']);
      } else {
        this.router.navigate(['/auth/login']);
      }
      return false;
    }

    if (this.authService.isAuthenticatedGovBr()) {
      // No reforço via GovBR, o próprio modal inclui o formulário de representação
      if (acao === 'reforcar') {
        return true;
      }

      const podeAgir = sessionStorage.getItem(PODE_ACAO_DEMANDA_KEY);
      if (!podeAgir) {
        console.info('User authenticated by Gov.br — redirecting to cadastro tipo representação');
        this.router.navigate(['/cadastro-tipo-representacao-govbr']);
        return false;
      }
      sessionStorage.removeItem(PODE_ACAO_DEMANDA_KEY);
      console.info('User authenticated by Gov.br — tipo representação cadastrado, prosseguindo');
    }

    return true;
  }
}

export const demandaAcaoGuard: CanActivateFn = () => {
  return inject(DemandaAcaoGuardService).canProceed();
}
